import React, { Component } from 'react'
import SimpleTabs from './components/CategoryTabPanel';

class CategoryTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default CategoryTab
  